import {mapGetters} from 'vuex';

export default {
    name: 'guidePaginate',
    computed: {
        ...mapGetters('guide', ['guide']),
        paginater() {
            return this.guide.paginationText && this.guide.paginationText.replace(/textMargin/g, 'link');
        }
    }
};